import { ITienDoNhapDiemLopHanhChinhRequest } from "../../../model/request/tong-hop/ITienDoNhapDiemLopHanhChinhRequest";
import { ITienDoNhapDiemLopHanhChinhResponse } from "../../../model/response/tong-hop/ITienDoNhapDiemLopHanhChinhResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTienDoNhapDiemLopHanhChinhActionsObj = {
    THANH_PHAN_LOAD_START: {} as ITienDoNhapDiemLopHanhChinhRequest,
    THANH_PHAN_LOAD_SUCCESS: {} as ITienDoNhapDiemLopHanhChinhResponse[],
    THANH_PHAN_LOAD_ERROR: "",

    THI_LOAD_START: {} as ITienDoNhapDiemLopHanhChinhRequest,
    THI_LOAD_SUCCESS: {} as ITienDoNhapDiemLopHanhChinhResponse[],
    THI_LOAD_ERROR: "",   
}

export const eTienDoNhapDiemLopHanhChinhActionIds = generateActionTypeIds(eTienDoNhapDiemLopHanhChinhActionsObj, "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH");
export type ITienDoNhapDiemLopHanhChinhActionTypes = IGenericActionType<typeof eTienDoNhapDiemLopHanhChinhActionsObj, "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH">;